import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import MetaBanner from "@components/MetaBanner"

const BannerModule = ({
  pageLocation,
  resourceValue = "schrott24",
  ...params
}) => {
  const { t } = useTranslation()
  const { pathname, search } = pageLocation || {}
  // const source = 'schrott24';

  if (!search) {
    return null
  }

  if (search.includes("resource=schrott24")) {
    return (
      <MetaBanner
        {...params}
        header={t("Redirect_Banner_Header")}
        contentText={t("Redirect_Banner_Body")}
        pathname={pathname}
      ></MetaBanner>
    )
  }

  if (search.includes("resource=pricead")) {
    return (
      <MetaBanner
        {...params}
        header={t("price_ad_header")}
        contentText={t("price_ad_body")}
        pathname={pathname}
      ></MetaBanner>
    )
  }

  return null
}

export default BannerModule
